import script from "./StepFreeText.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepFreeText.vue?vue&type=script&setup=true&lang=ts"

import "./StepFreeText.vue?vue&type=style&index=0&id=71d0b120&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d0b120"]])

export default __exports__